import { render, staticRenderFns } from "./reservationsComponent.vue?vue&type=template&id=c3420e52&scoped=true"
import script from "./reservationsComponent.vue?vue&type=script&lang=js"
export * from "./reservationsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3420e52",
  null
  
)

export default component.exports